import Facebook from '@lendi-ui/icon/Facebook';
import Twitter from '@lendi-ui/icon/Twitter';
import Linkedin from '@lendi-ui/icon/Linkedin';
import Youtube from '@lendi-ui/icon/Youtube';

export const MAIN_PAGES = [
  {
    category: 'Home Loans',
    categoryURL: '/home-loans/search',
    pageList: [
      {
        label: 'Find your home loan',
        url: '/home-loans/basics/',
      },
      {
        label: 'Refinance your loan',
        url: '/home-loans/refinance/',
      },
      {
        label: 'Buy your first home',
        url: '/home-loans/first-home-buyer/',
      },
      {
        label: 'Buy your next home',
        url: '/home-loans/buying/',
      },
      {
        label: 'Invest in property',
        url: '/home-loans/investment/',
      },
      {
        label: 'Build your home',
        url: '/home-loans/construction/',
      },
      {
        label: 'Property value report',
        url: '/property-report/',
      },
      {
        label: 'Find your Lendi expert',
        url: '/mortgage-broker/',
      },
    ],
  },
  {
    category: 'Calculators',
    categoryURL: '/calculators/',
    pageList: [
      {
        label: 'Repayment calculator',
        url: '/calculators/home-loan-repayment-calculator/',
      },
      {
        label: 'Borrowing power calculator',
        url: '/home-loans/basics/borrowing-power/',
      },
      {
        label: 'Offset calculator',
        url: '/calculators/offset-calculator/',
      },
      {
        label: 'Home equity calculator',
        url: '/calculators/equity-calculator/',
      },
      {
        label: 'LMI calculator',
        url: '/calculators/home-loans/lmi-calculator/',
      },
      {
        label: 'Debt consolidation calculator',
        url: '/calculators/home-loans/debt-consolidation-calculator/',
      },
      {
        label: 'Stamp duty calculator',
        url: '/home-loans/stamp-duty/calculator/?page=0',
      },
      {
        label: 'Free property report',
        url: '/property-report/',
      },
    ],
  },
  {
    category: 'Get inspired',
    categoryURL: '/inspire/',
    pageList: [
      {
        label: 'Home design',
        url: '/inspire/category/design/',
      },
      {
        label: 'Lendi homes',
        url: '/inspire/category/lendi-homes/',
      },
      {
        label: 'Finance',
        url: '/inspire/category/finance/',
      },
      {
        label: 'Property',
        url: '/inspire/category/property/',
      },
      {
        label: 'Lifestyle',
        url: '/inspire/category/lifestyle/',
      },
      {
        label: 'Insights',
        url: '/inspire/category/insights/',
      },
    ],
  },
  {
    category: 'FAQs',
    categoryURL: '/home-loans/',
    pageList: [
      {
        label: 'Understanding home loans',
        url: '/home-loans/',
      },
      {
        label: 'First home owners',
        url: '/home-loans/first-home-owner-grant/',
      },
      {
        label: 'Fees',
        url: '/inspire/property/a-guide-to-the-upfront-costs-of-buying-a-home/',
      },
      {
        label: 'Property reports',
        url: '/inspire/property/how-much-is-my-house-worth/',
      },
      {
        label: 'Investing in property',
        url: '/inspire/finance/investing-101-know-before-investing-in-property/',
      },
      {
        label: 'What does Lendi do',
        url: '/about-us/',
      },
      {
        label: 'Loan types',
        url: '/inspire/finance/fixed-variable-split-rate-home-loans-which-is-right-for-you/',
      },
      {
        label: 'Finance',
        url: '/inspire/finance/how-to-get-financially-ready-to-buy-a-home/',
      },
      {
        label: 'Repayments',
        url: '/calculators/home-loan-repayment-calculator/',
      },
      {
        label: 'Rates',
        url: '/home-loans/interest-rates/',
      },
    ],
  },
];

export const GENERAL_PAGES = [
  {
    label: 'About us',
    url: '/about-us/',
  },
  {
    label: 'Media',
    url: '/about-us/media/',
  },
  {
    label: 'Careers',
    url: 'https://lendi.recruiterbox.com',
  },
  {
    label: 'Privacy policy',
    url: '/privacypolicy/',
  },
  {
    label: 'Credit guide',
    url: '/creditguide/',
  },
  {
    label: 'Contact us',
    url: '/contactus/',
  },
];

export const SOCIAL_LOGO_AND_LINKS = [
  {
    logo: Facebook,
    url: 'https://www.facebook.com/lendiau/',
  },
  {
    logo: Twitter,
    url: 'https://twitter.com/lendiau',
  },
  {
    logo: Linkedin,
    url: 'https://www.linkedin.com/company/lendi',
  },
  {
    logo: Youtube,
    url: 'https://www.youtube.com/channel/UClqvf6ktIXZtlD556hyFq1g/featured',
  },
];
